import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import {
  resolveAppPrimaryColor,
  resolveAppPrimaryDarkColor,
  resolveProductKey,
} from "@/utils/productIdentity.js";

Vue.use(Vuetify);

const isOpt = resolveProductKey() === "opt";

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: resolveAppPrimaryColor(),
        secondary: isOpt ? "#001529" : resolveAppPrimaryDarkColor(),
        accent: resolveAppPrimaryColor(),
      },
    },
  },
});
